/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Chips_SubscriptionInputs */

const en_landing_chips_subscription = /** @type {(inputs: Landing_Chips_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscriptions`)
};

const zh_landing_chips_subscription = /** @type {(inputs: Landing_Chips_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订阅管理`)
};

/**
* | output |
* | --- |
* | "Subscriptions" |
*
* @param {Landing_Chips_SubscriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_chips_subscription = /** @type {((inputs?: Landing_Chips_SubscriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Chips_SubscriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_chips_subscription(inputs)
	return zh_landing_chips_subscription(inputs)
});
export { landing_chips_subscription as "landing.chips.subscription" }